import { __rest } from "tslib";
import { createElement } from 'react';
import classNames from 'classnames';
import _colors from '@vtblife/uikit-theme/classes/color-primitives.module.css';
import _variants from './fonts.module.css';
import _colorsNamed from './colors-named.module.css';
import normalizeCSSModules from '../../utils/css-modules';
var variants = normalizeCSSModules(_variants);
var colors = Object.assign(Object.assign({}, normalizeCSSModules(_colors)), normalizeCSSModules(_colorsNamed));
export var Typography = function Typography(_a) {
  var _a$tag = _a.tag,
    tag = _a$tag === void 0 ? 'div' : _a$tag,
    className = _a.className,
    color = _a.color,
    variant = _a.variant,
    responsive = _a.responsive,
    bold = _a.bold,
    children = _a.children,
    props = __rest(_a, ["tag", "className", "color", "variant", "responsive", "bold", "children"]);
  return createElement(tag, Object.assign({
    className: classNames(color && colors[color], variant && variants[variant], responsive && variants.responsive, bold && variants.bold, className)
  }, props), children);
};